<template>
  <html>
    <head>
        <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bulma@0.9.1/css/bulma.min.css">
    </head>
    <body>
      <img src="/thrillter_logo.png" width="110" style="position:absolute;z-index:50;top:10px;">
      <nav class="navbar" role="navigation" aria-label="main navigation" style="background-color:#37203A;">
        <div class="navbar-brand">
          <a class="navbar-item" href="/">
            <div class="subtitle has-text-white" style="margin-left:110px;font-weight:500;"><span class="strapline">Cult movies filtered for cheap thrills!</span></div>
          </a>
        </div>
      </nav>
      <main>
        <section id="app" class="has-background-dark">          
          <modal name="video-player-modal"
            width="1280"
            height="720" 
            @opened="videoPlayerOnShow">
            <div slot="top-right">
                <button @click="$modal.hide('video-player-modal')">
                    <span class="icon">
                        <i class="fas fa-times-circle"></i>
                    </span>
                </button>
              </div>
            <div id="video-player"></div>
          </modal>
          <router-view 
            @scroll="scrollPos = $event" 
            :scrollPos="scrollPos"
            :imageBaseUrl="imageBaseUrl"
            @show-video="showVideoPlayer" />
        </section>
      </main>
    </body>
  </html>
</template>
<script>
export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      scrollPos: 0,
      videoPlayer: null,
      currentVideoId: null,
      imageBaseUrl: "https://image.tmdb.org/t/p/"
    };
  },  
  methods: {
    showVideoPlayer: function(videoId) {
      this.currentVideoId = videoId;
      this.$modal.show('video-player-modal')
      // this.$nextTick(() => this.$modal.show('video-player-modal'));
    },
    videoPlayerOnShow: function() {
      //this.videoPlayer.loadVideoById(this.currentVideoId);
      this.videoPlayer = new YT.Player('video-player', {
          width: 1280,
          height: 720,
          videoId: this.currentVideoId,
          events: {
            'onReady': function(){ console.log('ready')},
          }
      });      
    },
    onPlayerReady: function() {
      console.log('player read')
    }
  },
  mounted() {
    let faScript = document.createElement('script')
    faScript.setAttribute('src', 'https://kit.fontawesome.com/d3c175038d.js');
    faScript.setAttribute('crossorigin', 'anonymous');
    document.head.appendChild(faScript);
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // window.onYouTubeIframeAPIReady = () => {

    // }
  },  
}
</script>
<style>
.logo {
  font-weight: bolder;
}
.strapline {
  font-weight:500;
  font-style: italic;
}
.ais-SearchBox-input, .ais-RefinementList-item {
  font-size:0.9em;
}
.vm--overlay {
  background:rgba(0, 0, 0, 0.8);
}
</style>
